import { render, staticRenderFns } from "./ParentInfoModule.vue?vue&type=template&id=c7142856&"
import script from "./ParentInfoModule.vue?vue&type=script&lang=js&"
export * from "./ParentInfoModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports